export const uzUZ = {
  app: {
    categories: {
      convectors: 'Конвекторы',
      decorative: 'Декоративные',
      electric: 'Электрические',
      panels: 'Панельные',
      towel: 'Полотенцесушители',
    },
    categoryLabel: 'Категория',
    categoryPlaceholder: 'Выберите категорию',
    errorCategories: 'Не удалось загрузить категории.',
    errorPanels: 'Не удалось загрузить радиаторы.',
    loadingCategories: 'Загрузка категорий...',
    loadingPanels: 'Загрузка радиаторов...',
    panelLabel: 'Радиаторы',
    panelPlaceholder: 'Выберите радиатор',
    titles: {
      convectors: 'Калькулятор конвекторов',
      decorative: 'Калькулятор дизайнерских радиаторов',
      electric: 'Калькулятор электрических радиаторов',
      panels: 'Калькулятор панельных радиаторов',
      towel: 'Калькулятор полотенцесушителей',
    },
  },
  calc: {
    actionButton: 'Показать рассчитанные позиции',
    boost: 'Режим усиления',
    calculateRequiredButton: 'Рассчитать необходимую мощность',
    calculating: 'Расчет...',
    comfort: 'Комфортный режим',
    downloadLabel: 'Загрузить данные ({count})',
    emptyResults: 'Пока нет результатов.',
    errorMatch: 'Не удается рассчитать результаты.',
    errorTypes: 'Не удалось загрузить типы радиаторов.',
    flowTemp: 'Температура подачи C°',
    height: 'Высота',
    length: 'Длина',
    loadingTypes: 'Загрузка типов...',
    modeLabel: 'Режим',
    modes: {
      cooling: 'Охлаждение',
      heating: 'Отопление',
    },
    radiatorType: 'Тип радиатора',
    requiredWatts: 'Необходимая мощность (Вт)',
    resultsMessage: '{count} позиций доступно для выбранных параметров.',
    returnTemp: 'Температура обратная C°',
    roomTemp: 'Температура в помещении C°',
    selectAllLabel: 'Выбрать все позиции',
    selectItemLabel: 'Выберите позицию для загрузки',
    selectPanel: 'Выберите радиатор для расчета.',
    standby: 'Режим ожидания',
    tableHeaders: {
      calculatedWattage: 'Ват',
      co2Equivalent: 'Эквивалент CO2 на кг материала',
      depth: 'Ширина [мм]',
      description: 'Описание позиции',
      dop: 'DOP',
      eudop: 'EU DOP',
      height: 'Высота [мм]',
      itemId: 'Код позиции',
      length: 'Длина [мм]',
      waterContent: 'Объем воды',
      weight: 'Вес',
    },
    title: 'Расчеты',
    tolerance: 'Допустимо',
    typeCooling: 'Охлаждение',
    typeGroupLabel: 'Тип',
    typeHeating: 'Отопление',
  },
  existingRadiator: {
    description:
      'Этот калькулятор имеет только информативное назначение. Перед покупкой радиатора всегда консультируйтесь с профессиональным монтажником по точному расчету.',
    height: 'Высота радиатора',
    length: 'Длина радиатора',
    resultLabelTemplate:
      'Необходима тепловая мощность, рассчитанная при температуре системы {temp}',
    select: 'Выбрать',
    temperature: 'Tizim harorati',
    type: 'Тип радиатора',
  },
  matrixCalc: {
    axisHeight: 'Высота (мм)',
    axisLength: 'Длина (мм)',
    axisType: 'Тип',
    calculateButton: 'Calculate',
    displayLabel: 'Кўриниш',
    exportExcel: 'Excel га экспорт қилиш',
    exportPdf: 'PDF га экспорт қилиш',
    print: 'Чоп этиш',
    hideOutOfRange: 'Диапазондан ташқаридаги элементларни яшириш',
    showAll: 'Ҳаммасини кўрсатиш',
    loading: 'Loading...',
    lockHeight: 'Высота',
    lockLabel: 'Зафиксировать размер',
    lockLength: 'Длина',
    lockType: 'Тип',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Рассчитать',
    clearButton: 'Очистить все',
    fields: {
      ceilingHeight: 'Высота потолка',
      doorInsulation: 'Теплоизоляция дверей',
      floorInsulation: 'Теплоизоляция пола',
      glazingArea: 'Площадь остекления',
      glazingMode: 'Площадь остекления',
      glazingQuality: 'Качество остекления',
      length: 'Длина',
      outerWalls: 'Наружные стены',
      projectedDesignTemp: 'Расчетная температура воздуха снаружи (РТН) для местоположения здания',
      roofInsulation: 'Теплоизоляция крыши',
      roomArea: 'Площадь помещения',
      roomFloor: 'Пол',
      roomInsulation: 'Теплоизоляция помещения',
      roomPreset: 'Назначение помещения',
      roomTemperature: 'Температура в помещении',
      roomType: 'Тип помещения',
      uncertaintyFactor: 'Коэффициент неопределенности',
      ventilation: 'Уровень вентиляции',
      wallInsulation: 'Теплоизоляция стен',
      width: 'Ширина',
      windConditions: 'Ветровые условия',
      windowInsulation: 'Теплоизоляция окон',
    },
    intro:
      'Рассчитайте теплопотери помещения, чтобы выбрать подходящий радиатор из нашего ассортимента.',
    options: {
      glazing: {
        m2: 'м²',
        percent: '%',
      },
      glazingBands: {
        high: 'Более 20%',
        low: 'Менее 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Более 20%',
        below_10: 'Меньше 10%',
        from_10_to_20: 'От 10% до 20%',
        no_windows: 'Без окон',
      },
      insulationValue: {
        good: 'Хорошая',
        medium: 'Средняя',
        poor: 'Слабая',
        very_good: 'Очень хорошая',
      },
      qualityValue: {
        modern_excellent: 'Современные, отличная энергоэффективность',
        modern_good: 'Современные, хорошая энергоэффективность',
        old_poor: 'Старые, очень плохая энергоэффективность',
        traditional_medium: 'Традиционные, средняя энергоэффективность',
      },
      roomValue: {
        bathroom_24: 'Ванная комната (24 C°)',
        bedroom_20: 'Спальня (20 °C)',
        garage_12: 'Гараж (12 C°)',
        livingroom_22: 'Гостиная (22 C°)',
        storage_16: 'Кладовая (16 C°)',
      },
      select: 'Выбрать',
      storeyValue: {
        ground_multi: 'Первый этаж (многоэтажное здание)',
        ground_single: 'Первый этаж (одноэтажное здание)',
        interim: 'Средний этаж',
        top_multi: 'Верхний этаж (многоэтажное здание)',
      },
      temp: {
        climate_zone_1: 'РТН -12 °C',
        climate_zone_2: 'РТН -14 °C',
        climate_zone_3: 'РТН -16 °C',
        climate_zone_4: 'РТН -18 °C',
        climate_zone_5: 'РТН -20 °C',
        climate_zone_6: 'РТН -22 °C',
        climate_zone_7: 'РТН -24 °C',
        climate_zone_8: 'РТН -26 °C',
      },
      windInfluence: {
        normal: 'Нормальные',
        strong: 'Неблагоприятные',
        weak: 'Благоприятные',
      },
    },
    roomPresets: {
      bathroom: 'Hammom',
      bedroom: 'Yotoqxona',
      garage: 'Garaj',
      kitchen: 'Oshxona',
      living: 'Yashash xonasi',
      storage: 'Ombor',
    },
    sections: {
      dimensions: 'Размеры помещения',
      insulation: 'Теплоизоляция',
      placement: 'Расположение',
      result: 'Результат',
      temps: 'Температуры',
      ventilation: 'Вентиляция',
    },
    title: 'Калькулятор теплопотерь',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'Вт',
    },
    useButton: 'Использовать',
  },
  slider: {
    from: 'От',
    to: 'До',
    value: 'Значение',
  },
}
